import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MoneyInputDirective } from '../../../../utils/directives/money-input.directive';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PaymentMethodModel } from '../../../../domain/models/payment.model';

@Component({
  selector: 'app-payment-method-check',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MoneyInputDirective
  ],
  templateUrl: './payment-method-check.component.html',
  styleUrls: ['./payment-method-check.component.css']
})
export class PaymentMethodCheckComponent implements OnInit {
  @Input() method!: PaymentMethodModel;
  @Output() removed = new EventEmitter<string>();
  @Output() amountChanged = new EventEmitter<{ method: PaymentMethodModel; amount: number }>();

  // Validation touched states
  checkNumberTouched: boolean = false;

  ngOnInit(): void {}

  onRemove(): void {
    this.removed.emit(this.method.id);
  }

  onAmountChange(value: string): void {
    const parsed = Math.max(0, parseFloat(value) || 0);
    this.amountChanged.emit({ method: this.method, amount: parsed });
  }

  get isCheckNumberValid(): boolean {
    return !!(this.method.checkNumber && this.method.checkNumber.trim().length > 0);
  }

  get showCheckNumberError(): boolean {
    return this.checkNumberTouched && !this.isCheckNumberValid;
  }
}
